import { parsePassioFoodDetailFromRest } from "./parsePassioFoodDetailFromRest";
import { MACRO_FDC_NUTRIENT_IDS } from "@notemeal/nutrient-utils";
const MACRO_FDC_IDS = new Set(MACRO_FDC_NUTRIENT_IDS);
const DEFAULT_SERVING_WEIGHT_GRAMS = 100;
export const buildAddPassioFoodInput = (foodDetail, name, options) => {
    if (!foodDetail.refCode) {
        return null;
    }
    const selectedQuantity = foodDetail.amount.selectedQuantity || 1;
    const selectedUnit = foodDetail.amount.selectedUnit || "serving";
    const servingUnits = foodDetail.amount.servingUnits ?? [];
    const selectedUnitWeight = servingUnits.find(u => u.unitName === selectedUnit)?.value;
    const defaultServingWeight = (typeof foodDetail.defaultServingWeight === "number" && foodDetail.defaultServingWeight > 0
        ? foodDetail.defaultServingWeight
        : undefined) ??
        (typeof selectedUnitWeight === "number" && selectedUnitWeight > 0 ? selectedUnitWeight : undefined) ??
        DEFAULT_SERVING_WEIGHT_GRAMS;
    // fdcNutrientAmounts are already true per-100g after parsePassioFoodDetailFromRest.
    const fdcAmounts = foodDetail.fdcNutrientAmounts ?? [];
    const findPer100g = (fdcId) => fdcAmounts.find(n => n.fdcNutrientId === fdcId)?.amount ?? 0;
    const cho = findPer100g(1005);
    const pro = findPer100g(1003);
    const fat = findPer100g(1004);
    const kcal = findPer100g(1008);
    const nutrientAmounts = fdcAmounts
        .filter(na => !MACRO_FDC_IDS.has(na.fdcNutrientId))
        .map(na => ({
        fdcNutrientId: na.fdcNutrientId,
        amount: na.amount,
    }));
    const additionalServings = servingUnits
        .filter((unit) => !!unit.unitName && unit.unitName !== selectedUnit && typeof unit.value === "number")
        .map(unit => ({
        units: { customUnits: unit.unitName, unitPrefix: null, unitSuffix: null, unitId: null },
        weight: unit.value,
        defaultAmount: unit.defaultAmount && unit.defaultAmount > 0 ? unit.defaultAmount : 1,
    }));
    return {
        name,
        cho,
        pro,
        fat,
        kcal,
        defaultAmount: selectedQuantity,
        defaultServingWeight,
        units: {
            customUnits: selectedUnit,
            unitPrefix: null,
            unitSuffix: null,
            unitId: null,
        },
        additionalServings,
        nutrientAmounts,
        thumbnailUrl: options?.thumbnailUrl ?? null,
        passioItemRefCode: foodDetail.refCode,
    };
};
export const buildAddPassioFoodInputFromRest = (raw, name, options) => {
    const detail = parsePassioFoodDetailFromRest(raw);
    if (!detail) {
        return null;
    }
    return buildAddPassioFoodInput(detail, name, { thumbnailUrl: options?.thumbnailUrl });
};
//# sourceMappingURL=buildAddPassioFoodInput.js.map